<template>
    <div id="calibrationLabPage">
      <!-- <img src="../../assets/admin/images/iran.png" id="iranImage" alt=""> -->
     <!-- <span id="iranImage">  پروفايل كاربري آزمايشگاه كاليبراسيون  </span> -->
    <router-view></router-view>
    </div>
  </template>
  <script>
  // import the styles
  import adminMixin from "@/libraries/adminController.js";
  import { BModal, BButton, BOverlay, BSpinner } from "bootstrap-vue";
  export default {
    mixins: [adminMixin],
    components: {
      BModal,
      BButton,
      BOverlay,
      BSpinner,
    },
    data() {
      return {
        showMessage:false,
        items: null,
      };
    },
    mounted() {
      // this.$axios
      //   .get("SupplierMessage/GetUserMessage")
      //   .then((res) => {
      //     this.items = res.data.data;
      //   })
        // .catch((err) => {
        //   this.$toast.error(err.response.data.message);
        // });
    },
  };
  </script>
  <style scoped>
  div#userRole {
    width: 90%;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: center;
    margin: auto;
  }
  .message .date {
    position: absolute;
    left: 0;
    top: 0;
    padding: 5px;
}
.message {
    box-shadow: 0 0 5px #1213;
    padding: 15px;
    border-radius: 5px;
    display: flex;
    direction: rtl;
    position: relative;
}
div#calibrationLabPage {
  width: 100%;
  position: relative;
}
button#supplierMessageIcon path {
  fill: #edc739;
}
button#supplierMessageIcon svg {
  width: 60px;
  height: 60px;
}
button#supplierMessageIcon {
  background: transparent;
  border: none;
  position: absolute;
  left: 10px;
  top: 10px;
}
div#messageHeaderBox svg {
  width: 30px;
}
div#messageHeaderBox {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border-bottom: 1px solid grey;
  height: 80px;
}
div#supplierMessageSideBar {
  position: fixed;
  height: 100vh;
  background: white;
  box-shadow: 0 0 5pc #303030ab;
  min-width: 350px;
  left: 0;
  top: 0;
  animation: sideBar 0.7s linear forwards;
}
@keyframes sideBar{
  from{
    left: -350px;
  }
  to{
    left: 0;
  }
}
ul#messageContent li::marker {
  color: #5fff00;
  font-size: x-large;
}
ul#messageContent li span {
  color: #001a3e8f;
}

ul#messageContent li {
  border-bottom: 1px solid #1213;
}
ul#messageContent li p {
  text-align: right;
  direction: rtl;
}
ul#messageContent {
  list-style: inherit;
  padding: 24px;
  direction: rtl;
  height: calc(100vh - 80px);
    overflow: auto;
}
/* img#iranImage {
  position: fixed;
  left: 0;
  top: 0;
  width: 15%;
} */
/* #iranImage {
  position: fixed;

  text-align: center;
  width: 100%;
} */
  </style>
  